import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import "../css/cart.css";
import { getAllProducts } from "../actions/productActions";
import { useDispatch, useSelector } from "react-redux";

const ShareableCartScreen = () => {
  const [promocode, setPromocode] = useState("");
  const [promocodeValue, setPromocodeValue] = useState(null);
  const [searchQueryProduct, setSearchQueryProduct] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllProducts());
  }, []);

  const allProducts = useSelector((state) => state.allProducts);
  const { products } = allProducts;

  useEffect(() => {
    if (searchQueryProduct && !selectedProduct) {
      const filtered = products.filter((bike) =>
        bike.name
          .toLowerCase()
          .includes(
            searchQueryProduct.toLowerCase() && bike.status === "active"
          )
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }
  }, [searchQueryProduct, products, selectedProduct]);

  const handleSelectBike = (productName, productId) => {
    setSelectedProduct(productName);
    setSearchQueryProduct(productName);
    setFilteredProducts([]); // Hide the dropdown
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-2 p-0">
          <Sidebar active={8} />
        </div>
        <div className="col-lg-10 p-0">
          <div className="row p-5">
            <div className="col-lg-6 pe-lg-5  p-1">
              <div className="p-2 mt-3 mt-lg-2 pt-0">
                <h4 className="mb-0 fw-bold ">Shareable Cart Builder</h4>
                <div className="mb-lg-4 mb-3 col-12 col-md-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label text-light "
                  >
                    Search Product*
                  </label>
                  {products && (
                    <div style={{ position: "relative" }}>
                      <input
                        className="form-control w-100"
                        type="text"
                        required
                        style={{ padding: "0.7em" }}
                        placeholder="Search product by name"
                        value={searchQueryProduct}
                        onChange={(e) => {
                          setSearchQueryProduct(e.target.value);
                          setSelectedProduct(""); // Clear selectedDealer to show dropdown again
                        }}
                      />
                      {filteredProducts.length > 0 && (
                        <ul
                          className="rounded-3"
                          style={{
                            border: "1px solid #ccc",
                            maxHeight: "150px",
                            overflowY: "auto",
                            position: "absolute",
                            background: "#fff",
                            color: "black",
                            listStyleType: "none",
                            padding: 0,
                            width: "100%", // Match width to input field's width
                            zIndex: 1, // Ensure dropdown appears above other content
                          }}
                        >
                          {filteredProducts.map((bike, index) => (
                            <li
                              key={index}
                              onClick={() => handleSelectBike(bike.name)}
                              style={{
                                padding: "8px",
                                cursor: "pointer",
                              }}
                            >
                              {bike.name}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}
                </div>
                {/* <div className="cart-items p-3">
          {cartItems.map((item, i) => (
            <div key={i} className="cart-item mb-3 p-lg-2 pt-3 pb-3 row  ">
              <div className="col-lg-3 col-4  p-0">
                <img
                  src={item.cartImages[item.model]}
                  alt=""
                  className=" img-fluid  "
                />
              </div>
              <div className="col-4 offset-1 pt-3  ">
                <h6
                  className="mb-1"
                  style={{
                    fontWeight: "700",
                    fontSize: "20px",
                  }}
                >
                  {item.name}{" "}
                  {(item.variants || item.variant) && (
                    <>
                      <span>|</span>{" "}
                      <span>
                        {item.name === "Photon" || item.name === "Ray Light"
                          ? item.variants[item.variant].variant_name
                          : item.variants[item.variant].variantName}
                      </span>
                    </>
                  )}
                </h6>
                <p
                  className="mb-2"
                  style={{
                    fontSize: "0.8em",
                    color: "grey",
                  }}
                >
                  {item.models[item.model].colorName}
                </p>
                <h6
                  className="mb-0"
                  style={{
                    fontWeight: "700",
                    fontSize: "0.9em",
                    color: "#3CAB1F",
                  }}
                >
                  MRP: {currencyFormat(item.accPrice)}
                </h6>
              </div>
              <div className="col-3 offset-1 pt-3 position-relative ">
                <div className="d-flex">
                  <div
                    className="col-4"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <i
                      className="fa-solid fa-minus"
                      onClick={(e) => {
                        removeCart(
                          item.product,
                          item.productModel,
                          item.colorName,
                          item.name,
                          item.variantType
                        );
                      }}
                    ></i>
                  </div>
                  <p className="col-4 text-center">{item.qty}</p>
                  <div
                    className="col-4 text-end"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <i
                      className="fa-solid fa-plus"
                      onClick={(e) => {
                        dispatch(
                          addToCart(
                            item.product,
                            item.model,
                            item.color,
                            Number(item.qty + 1),
                            item.variant
                          )
                        );
                      }}
                    ></i>
                  </div>

                  <div
                    className="position-absolute"
                    style={{
                      bottom: "0%",
                      right: "0%",
                    }}
                  ></div>
                </div>
                <i
                  style={{
                    color: "#b8baba",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    dispatch(
                      resetCart(
                        item.productModel,
                        item.colorName,
                        item.name,
                        item.variant
                      )
                    )
                  }
                  className="fa-sharp mt-3 text-end d-block fa-solid fa-trash"
                ></i>
              </div>
            </div>
          ))}
        </div> */}
              </div>
            </div>
            <div className="col-1 d-none justify-content-center pb-5 d-lg-flex">
              <div className="border" style={{ width: "1px" }}></div>
            </div>
            <div className="col-lg-5   ps-lg-5 pe-lg-5 p-1">
              <div className="p-2 mt-3 mt-lg-2 pt-0">
                <div className=" pb-0 mb-4 d-none d-lg-block">
                  <div className="field-wrapper">
                    <input
                      type="text"
                      value={promocodeValue}
                      autoComplete="new-password"
                      // className={`${promocodeValue.length > 0 && "bg-white"}`}
                      onChange={(e) => setPromocodeValue(e.target.value)}
                      name="promocode value"
                      style={{
                        border: "2px dotted  #b1b3b6",
                      }}
                      id=""
                    />
                    <div className="field-placeholder">
                      <span>Enter Promocode Value</span>
                    </div>
                  </div>
                </div>
                <div className="order-summary">
                  <h6 className="cart-heading p-lg-4 p-3 pb-lg-2 mb-0">
                    ORDER SUMMARY
                  </h6>
                  <div
                    className="position-relative  "
                    style={{ height: "20px" }}
                  >
                    <div
                      className=" w-100 position-absolute"
                      style={{
                        borderBottom: "2px  dotted #BCB5B5",
                        top: "50%",
                      }}
                    ></div>
                    <div
                      className=" position-absolute "
                      style={{
                        background: "#f4f5f7",
                        height: "20px",
                        borderRadius: "50%",
                        width: "20px",
                        left: "-2%",
                      }}
                    ></div>
                    <div
                      className=" position-absolute"
                      style={{
                        background: "#f4f5f7",
                        borderRadius: "50%",
                        height: "20px",
                        width: "20px",
                        right: "-2%",
                      }}
                    ></div>
                  </div>

                  {/* <div className="mt-3 p-lg-4 p-3 pt-0 pb-lg-0 pt-lg-0">
            <div className=" justify-content-between d-flex">
              <p
                style={{
                  fontSize: "0.9em",
                  color: "grey",
                }}
              >
                Items
              </p>
              <p
                style={{
                  fontSize: "0.9em",
                  color: "grey",
                }}
              >
                {cartItems.reduce((acc, item) => acc + item.qty, 0)}
              </p>
            </div>
            <div className=" justify-content-between d-flex">
              <p
                style={{
                  fontSize: "0.9em",
                  color: "grey",
                }}
              >
                Sub Total
              </p>
              <p
                style={{
                  fontSize: "0.9em",
                  color: "grey",
                }}
              >
                {currencyFormat(
                  cartItems.reduce(
                    (acc, item) => acc + item.qty * item.accPrice,
                    0
                  )
                )}
              </p>
            </div>
            <div className=" justify-content-between d-flex">
              <p
                className="mb-2 col-6"
                style={{
                  fontSize: "0.9em",
                  color: "grey",
                }}
              >
                Delivery
              </p>
              <p
                className="mb-2 text-end"
                style={{
                  fontSize: "0.9em",
                  color: "grey",
                }}
              >
                <span className="col-5  text-end">
                  {Number(
                    cartItems.reduce(
                      (acc, item) => acc + item.qty * item.price,
                      0
                    )
                  ) > 249 ? (
                    <>
                      <span
                        className="me-2 "
                        style={{
                          textDecoration: "line-through",
                        }}
                      >
                        {currencyFormat(
                          cartItems.reduce(
                            (acc, item) =>
                              acc +
                                Number(
                                  cartItems.reduce(
                                    (acc, item) =>
                                      acc + item.qty * item.price,
                                    0
                                  )
                                ) >
                              5000
                                ? 2000
                                : 40,
                            0
                          )
                        )}
                      </span>
                      <span className=""> FREE</span>{" "}
                    </>
                  ) : (
                    currencyFormat(40)
                  )}
                </span>
              </p>
            </div>
            {Number(
              cartItems.reduce((acc, item) => acc + item.qty * item.price, 0)
            ) < 249 && (
              <span
                style={{
                  fontWeight: "500",
                  fontSize: "0.85em",
                }}
                className="d-block text-danger text-lg-end"
              >
                {" "}
                Shop for ₹
                {249 -
                  Number(
                    cartItems.reduce(
                      (acc, item) => acc + item.qty * item.price,
                      0
                    )
                  )}{" "}
                more to get <span>FREE</span> delivery
              </span>
            )}

            {
              promocodes && (
                // promocodes.type === "flat" ? (
                // cartItems.find((value) => {
                //     return promocodes.for.includes(value.product);
                //   }) &&
                <div className="mt-1 justify-content-between d-flex">
                  <p
                    style={{
                      fontSize: "0.9em",
                      color: "grey",
                    }}
                  >
                    Discount
                  </p>
                  <p
                    style={{
                      fontSize: "0.9em",
                      color: "grey",
                    }}
                  >
                    FLAT{" "}
                    {promocodes.discountType !== "percentage"
                      ? `₹ ${promocodes.discountValue} OFF`
                      : `${promocodes.discountValue}% OFF`}{" "}
                    {promocodes.category ? `on ${promocodes.category}` : ""}
                  </p>
                </div>
              )
              // ) : (
              //   promocodes &&
              //   promocodes.length > 0 &&
              //   promocodes[0].type !== "flat" && (
              //     <div className="mt-1 justify-content-between d-flex">
              //       <p
              //         style={{
              //           fontSize: "0.9em",
              //           color: "grey",
              //         }}
              //       >
              //         Discount
              //       </p>
              //       <p
              //         style={{
              //           fontSize: "0.9em",
              //           color: "grey",
              //         }}
              //       >
              //         {promocodes[0].desc}
              //       </p>
              //     </div>
              //   )
              // )
            }
          </div>
          <div className="position-relative  " style={{ height: "20px" }}>
            <div
              className=" w-100 position-absolute"
              style={{
                borderBottom: "2px  dotted #BCB5B5",
                top: "50%",
              }}
            ></div>
            <div
              className=" position-absolute "
              style={{
                background: "#fff",
                height: "20px",
                borderRadius: "50%",
                width: "20px",
                left: "-2%",
              }}
            ></div>
            <div
              className=" position-absolute "
              style={{
                background: "#fff",
                borderRadius: "50%",
                height: "20px",
                width: "20px",
                right: "-2%",
              }}
            ></div>
          </div>
          <div className=" p-3 pb-1 justify-content-between d-flex p-lg-4 pb-lg-2 pt-lg-2">
            <p
              className=""
              style={{
                fontWeight: "600",
              }}
            >
              Total
            </p>
            <p
              style={{
                fontWeight: "600",
              }}
            >
              {currencyFormat(
                Number(
                  cartItems.reduce(
                    (acc, item) => acc + item.qty * item.accPrice,
                    0
                  )
                ) > 249
                  ? Math.max(
                      0,
                      Number(
                        cartItems.reduce(
                          (acc, item) => acc + item.qty * item.accPrice,
                          0
                        )
                      ) -
                        (promocodes
                          ? promocodes.discountType === "amount"
                            ? promocodes.discountValue
                            : promocodes.applicableProducts.length
                            ? (promocodes.discountValue / 100) *
                              Number(
                                cartItems
                                  .filter((item) =>
                                    promocodes.applicableProducts.includes(
                                      item.product
                                    )
                                  ) // Filter out items whose id is not in applicableProducts
                                  .reduce(
                                    (acc, item) =>
                                      acc + item.qty * item.accPrice,
                                    0
                                  ) // Calculate the total
                              )
                            : (promocodes.discountValue / 100) *
                              Number(
                                cartItems.reduce(
                                  (acc, item) =>
                                    acc + item.qty * item.accPrice,
                                  0
                                )
                              )
                          : 0)
                    )
                  : Math.max(
                      0,
                      40 +
                        Number(
                          cartItems.reduce(
                            (acc, item) => acc + item.qty * item.accPrice,
                            0
                          )
                        ) -
                        (promocodes
                          ? promocodes.discountType === "amount"
                            ? promocodes.discountValue
                            : promocodes.applicableProducts.length
                            ? (promocodes.discountValue / 100) *
                              Number(
                                cartItems
                                  .filter((item) =>
                                    promocodes.applicableProducts.includes(
                                      item.product
                                    )
                                  ) // Filter out items whose id is not in applicableProducts
                                  .reduce(
                                    (acc, item) =>
                                      acc + item.qty * item.accPrice,
                                    0
                                  ) // Calculate the total
                              )
                            : (promocodes.discountValue / 100) *
                              Number(
                                cartItems.reduce(
                                  (acc, item) =>
                                    acc + item.qty * item.accPrice,
                                  0
                                )
                              )
                          : 0)
                    )
              )}
            </p>
          </div> */}
                </div>
                <div className="mt-3">
                  <button
                    type="Submit"
                    style={{
                      background: "#004dac",
                      color: "#fff",
                    }}
                    className="btn p-3 w-100"
                  >
                    Create Link
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShareableCartScreen;
